import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "../url";

export const deleteDepartment = async (departmentId) => {
  try {
    const token = Cookies.get("Bearer");
    const response = await axios.delete(
      `${FIRMFLOWURL}api/Department/delete/${departmentId}`,
      {
        headers: { Authorization: token },
      }
    );

    return {
      success: response.data?.success ?? true,
      message:
        response.data?.message ||
        response.data?.Message ||
        "Department deleted successfully",
      blockers: response.data?.blockers || response.data?.Blockers || [],
      data: response.data,
      status: response.status,
    };
  } catch (err) {
    console.log("error deleting department", err);

    if (err.response?.status === 401 || err.message?.includes("401")) {
      Cookies.remove("Bearer");
      window.location.replace("/");
      return {
        success: false,
        message: "Unauthorized",
        blockers: [],
        status: 401,
      };
    }

    return {
      success: false,
      message:
        err.response?.data?.message ||
        err.response?.data?.Message ||
        err.response?.data?.title ||
        err.message ||
        "Department could not be deleted",
      blockers: err.response?.data?.blockers || err.response?.data?.Blockers || [],
      data: err.response?.data,
      status: err.response?.status,
    };
  }
};
